import React, { useState, forwardRef } from "react";
import Stars from "./Stars";
import styled from "styled-components";
import classNames from "classnames";
import IBuildrProps from "../../utilities/IBuildrProps";


export interface IReviewProps extends IBuildrProps {
    name: string;
    date: string;
    score: string;
    body: any;
}

function TextExpander({ expanded, onClick }) {
    if (expanded) {
        return (
            <a href="#" className="ml-2" onClick={onClick}>less</a>
        );
    } else {
        return (
            <>...<a href="#" className="ml-2 expanding-link" onClick={onClick}>more</a></>
        );
    }
}

const Review = styled(forwardRef(({ name, score, date, body = "", className, cmsId, editorClassObj }: IReviewProps, ref: any) => {
    const [expanded, setExpanded] = useState(false);

    function toggleExpand(e) {
        e.preventDefault();
        setExpanded(!expanded);
    }

    return (
        <div data-id={cmsId} ref={ref} className={classNames(className, editorClassObj, "column-no-break", "mb-4", "review-container")}>
            <div className="mb-2">
                <span className="google-icon"></span>
                <span className="ml-1 review-name">
                    <strong>{name}</strong>
                </span>
            </div>
            <div>
                <Stars score={score} />
                <span className="ml-2">{date}</span>
            </div>
            <div>
                {expanded ?
                    <>
                        {body}
                        {body.length > 140 && <TextExpander expanded={expanded} onClick={toggleExpand} />}
                    </>
                    :
                    <>
                        {body.substr(0, 140)}
                        {body.length > 140 && <TextExpander expanded={expanded} onClick={toggleExpand} />}
                    </>
                }
            </div>
        </div>
    );
}))`
    .google-icon {
        // background: url(https://www.macu.com/MACU/Images/googleplus.png) no-repeat;
        background-size: contain;
        width: 25px;
        display: inline-block;
        height: 25px;
        vertical-align: bottom;
        padding-right: 10px;
    }
`;

export default Review;
(global as any).Review = Review;